<template>

    <header id="header" class="header fixed-top d-flex align-items-center">

        <div class="d-flex align-items-center justify-content-between">
            <router-link class="logo2 d-flex align-items-center" to="/">
                <img :src="imageLogo" alt="" style="max-height: 3em;">
                <!-- <span class="d-none d-lg-block">Megacad</span> -->
            </router-link>

            <i class="bi bi-list toggle-sidebar-btn" @click="toggleSidebar"></i>
        </div>

        <!-- <button class="btn btn-secondary" @click="logout">Cerrar Sesión</button> -->

        <nav class="header-nav ms-auto">
            <ul class="d-flex align-items-center">

                <li class="nav-item d-block d-lg-none">
                    <a class="nav-link nav-icon search-bar-toggle " href="#">
                        <i class="bi bi-search"></i>
                    </a>
                </li>


                <li class="nav-item dropdown pe-3" v-if="true">

                    <a class="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                        <img :src="imageProfile" alt="Profile" class="rounded-circle">
                        <span class="d-none d-md-block dropdown-toggle ps-2">{{ accountUser.first_name }} {{ accountUser.last_name }}</span>
                    </a>

                    <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                        <li class="dropdown-header">
                            <h6>{{ accountUser.first_name }} {{ accountUser.last_name }}</h6>
                            <span>{{ accountUser.role_name }}</span>
                            <br />
                            <span>{{ accountUser.email }}</span>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>

                        <li>
                            <router-link to="/Profile" class="dropdown-item d-flex align-items-center">
                                <i class="bi bi-person"></i>
                                <span>Mi Perfil</span>
                            </router-link>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>

                        <li>
                            <hr class="dropdown-divider">
                        </li>

                        <li>
                            <a class="dropdown-item d-flex align-items-center" href="#" @click="logout">
                                <i class="bi bi-box-arrow-right"></i>
                                <span>Cerrar Sesión</span>
                            </a>
                        </li>

                    </ul>

                </li>

                <li class="nav-item dropdown pe-3" v-else>
                    <a class="nav-link dropdown-toggle" href="#">
                        <i class="bi bi-box-arrow-right"></i>
                        <span>Iniciar Sesión</span>
                    </a>
                </li>

            </ul>
        </nav>

    </header>
</template>

<script>

import { eventBus } from '@/event-bus';
import accountMixin from '@/mixins/accountMixin';
import $ from 'jquery';

export default {

    name: 'Header',

    mixins: [accountMixin,],

    data() {

        return {

            imageLogo: require('@/assets/images/logo-smart-horizontal.png'),
            imageProfile: require('@/assets/images/profile.png'),
            
            sidebarOpen: false,
        };
    },

    mounted() {

        $(document).off("click", ".toggle-sidebar-btn").on("click", ".toggle-sidebar-btn", function () {
            
            // $("body").toggleClass("toggle-sidebar");

            // // Si es móvil, también alterna sidebar-mobile
            // if (window.innerWidth <= 768) {

            //     $("body").toggleClass("sidebar-mobile");
            // }
        });
    },

    methods: {

        toggleSidebar() {

            this.sidebarOpen = !this.sidebarOpen;
            eventBus.emit('toggle-sidebar', this.sidebarOpen);
        },

        logout() {

            localStorage.removeItem("token"); // Limpiar el token
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("user"); // Limpiar el user
            localStorage.removeItem("extra_data"); // Limpiar el user
            this.$router.push("/login"); // Redirigir al login
        },
    },
};

</script>

<style scoped>
    /* Estilos específicos del header (si es necesario) */
</style>